module.exports = __webpack_public_path__ + "img/slide2.3db35729.jpg";